// gatsby-browser.js AND gatsby-ssr.js
import React from "react";
import { LessonProvider } from "./src/utils/context/LessonContext";

export const wrapRootElement = ({ element }) => (
  <LessonProvider>{element}</LessonProvider>
);
